import api from "../api";

const auth = {
  login(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/users/login",
        payload,
        data => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  signup(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/users/signup/",
        payload,
        data => resolve(data),
        error => reject(error)
      );
    });
  },
  sendEmail(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/users/forgot-password/",
        payload,
        data => resolve(data),
        error => reject(error)
      );
    });
  },
  setNewPassword(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/users/new-password/",
        payload,
        data => resolve(data),
        error => reject(error)
      );
    });
  },
  getNewAccessToken(payload) {
    return new Promise((resolve, reject) => {
      api.delete(
        "/users/token/",
        payload,
        data => resolve(data),
        error => reject(error)
      );
    });
  },
  logout(payload) {
    return new Promise((resolve, reject) => {
      api.delete(
        "/users/logout/",
        payload,
        data => resolve(data),
        error => reject(error)
      );
    });
  }
};

export default auth;
